<template>
  <div class="right-side right-side-reverse">
    <ul class="vertical-menu">

      <li class="personal-info-box">
        <div class="personal-head">
          <div class="img-wrap">
            <img
              :src="$API_URL+'storage/'+employeeData.image"
              alt="Profile image"
              width="80"
              height="80"
              v-if="employeeData.image !== ''"
            />
            <span v-if="employeeData.image === ''" class="profile-name text-uppercase">
                                    {{ getNameFirstLetter2(employeeData.name,'F1') }}
                                  </span>
            <a class="load-img" href="#" data-toggle="modal" data-target="#profile-pic-modal"><i class="fas fa-camera"></i></a>

          </div>
          <div class="img-dtl">
            <strong class="personal-name text-capitalize"> {{ employeeData.name }}</strong>

            <span class="pr-5" v-for="jobrole in employeeData.employeeJobType" :key="jobrole.id">
              <i class="ico ico-fill-circle paddingRight2"  :style="'color:'+jobrole.get_job_roles.color"></i>
              {{ jobrole.get_job_roles.name }}</span>
          </div>
        </div>
      </li>
      <li :class="{active:this.$route.path.startsWith('/employee/profile')}">
        <router-link :to="{ path: '/employee/profile/' + employeeData.uuid + '' }"
        ><span class="icon-wrp"
        ><img
          :src="require('@/assets/images/personal.png')"
          alt="icon" /></span
        >personal info</router-link
        >
      </li>
      <li :class="{active:this.$route.path.startsWith('/employee/detail')}" v-if="isRouteAccess">
        <router-link :to="{ path: '/employee/detail/' + employeeData.uuid + '' }"
        ><span class="icon-wrp"
        ><img
          :src="require('@/assets/images/Employment.png')"
          alt="icon" /></span
        >Employment Details</router-link
        >
      </li>
      <li :class="{active:this.$route.path.startsWith('/employee/shift')}">
        <router-link :to="{ path: '/employee/shift/' + employeeData.uuid + '' }"
          ><span class="icon-wrp"
            ><img :src="require('@/assets/images/user.png')" alt="icon"
          /></span>
           Shifts</router-link
        >
      </li>
      <li :class="{active:this.$route.path.startsWith('/employee/hours')}">
        <router-link :to="{ path: '/employee/hours/' + employeeData.uuid + '' }"
        ><span class="icon-wrp"
        ><img
          :src="require('@/assets/images/Hours.png')"
          alt="icon" /></span
        >Hours</router-link
        >
      </li>
      <li :class="{active:this.$route.path.startsWith('/employee/absence')}">
        <router-link :to="{ path: '/employee/absence/' + employeeData.uuid + '' }"
          ><span class="icon-wrp"
            ><img
              :src="require('@/assets/images/Leaves.png')"
              alt="icon" /></span
          >My Leaves</router-link
        >
      </li>


      <li :class="{active:this.$route.path.startsWith('/employee/salary')}">
        <router-link :to="{ path: '/employee/salary/' + employeeData.uuid + '' }"
          ><span class="icon-wrp"
            ><img
              :src="require('@/assets/images/SalarySlip.png')"
              alt="icon" /></span
          >Salary Slip</router-link
        >
      </li>

      <li :class="{active:this.$route.path.startsWith('/employee/balance')}">
        <router-link :to="{ path: '/employee/balance/' + employeeData.uuid + '' }"
          ><span class="icon-wrp"
            ><img
              :src="require('@/assets/images/SalarySlip.png')"
              alt="icon" /></span>Salary</router-link>
      </li>
      <li :class="{active:this.$route.path.startsWith('/employee/chart-of-account')}" v-if="isRouteAccess">
        <router-link
          :to="{ path: '/employee/chart-of-account/' + employeeData.uuid + '' }"
          ><span class="icon-wrp"
            ><img  :src="require('@/assets/images/SalarySlip.png')" alt="icon" /></span
          >Chart of Account</router-link
        >
      </li>
      <li :class="{active:this.$route.path.startsWith('/employee/documents')}">
        <router-link
          :to="{ path: '/employee/documents/' + employeeData.uuid + '' }"
          ><span class="icon-wrp"
            ><img  :src="require('@/assets/images/SalarySlip.png')" alt="icon" /></span
          >Documents </router-link
        >
      </li>
      <li :class="{active:this.$route.path.startsWith('/employee/benefits')}" v-if="isRouteAccess">
        <router-link
          :to="{ path: '/employee/benefits/' + employeeData.uuid + '' }"
          ><span class="icon-wrp"
            ><img
              :src="require('@/assets/images/Benefits.png')"
              alt="icon" /></span
          >Benefits</router-link
        >
      </li>
      <li :class="{active:this.$route.path.startsWith('/employee/permissions')}" v-if="isRouteAccess">
        <router-link
          :to="{ path: '/employee/permissions/' + employeeData.uuid + '' }"
          ><span class="icon-wrp"
            ><img
              :src="require('@/assets/images/Benefits.png')"
              alt="icon" /></span
          >Permissions</router-link
        >
      </li>
      <li :class="{active:this.$route.path.startsWith('/employee/report-to')}">
        <router-link
          :to="{ path: '/employee/report-to/' + employeeData.uuid + '' }"
          ><span class="icon-wrp"
            ><img
              :src="require('@/assets/images/Benefits.png')"
              alt="icon" /></span
          >Report To</router-link
        >
      </li>
      <li :class="{active:this.$route.path.startsWith('/employee/locationLog')}" v-if="isRouteAccess">
        <router-link
          :to="{ path: '/employee/locationLog/' + employeeData.uuid + '' }"
          ><span class="icon-wrp"
            ><img :src="require('@/assets/images/map.png')" alt="icon" /></span
          >Logs</router-link
        >
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name:"employeeSidebar",
  props:[
    "employeeData"
  ],
  data(){
    return {
      isRouteAccess: false,
      user : this.$store.getters.getUser
    }
  },
  created(){
    this.isRouteAccess=this.routeAndPageAccess(this.$store.getters.getLoginInProfile);
  },
  mounted() {
    // console.log(this.user,'user');
  },
  methods:{
    getNameFirstLetter2(name,tp){
      return this.getNameFirstLetter(name);
    },
  }
}
</script>
<style scoped>
.paddingRight2{
  padding-right: 2px !important;
}
.personal-info-box .personal-head .img-wrap{
  flex-shrink: 0;
}
.personal-info-box .personal-head .img-dtl{
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
}
.personal-info-box .personal-head .personal-name{ width: 100%;}

</style>
